import axios from 'axios';


export default {
    signIn (username, password, keepSession) {
        var authenticationRequest = {username: username, password: password, keepSession: keepSession}
        return axios.post('/api/auth/signin', authenticationRequest)
        .then(response => {
            if (response && response.data) return response.data;
        })
    },
    signInValidationWithOAuth2(provider, code) {
        return axios.get('/api/auth/oAuth2/login/code/',{params :{code:code ,provider:provider}} )
        .then(response => {
            if (response && response.data) return response.data;
        })
    },
    signInWithOauth2Validate(oauthProvider, oAuth2AccessToken, username) {
        console.log(oauthProvider, oAuth2AccessToken, username)
        return axios.post('/api/auth/oAuth2/login/validate/',{oauthProvider:oauthProvider ,oAuth2AccessToken:oAuth2AccessToken , username:username} )
        .then(response => {
            if (response && response.data) return response.data;
        })
    },
    signInWithOAuth2 (provider) {
        return axios.get('/api/auth/oAuth2/login',{params :{provider:provider}})
        .then(response => {
            if (response && response.data) return response.data;
        })
    },

    refresh (refreshToken) {
        var request = {refreshToken: refreshToken}
        return axios.post('/api/auth/refresh', request)
        .then(response => {
            if (response && response.data) return response.data;
        })
    },

    logout () {
        return axios.post('/api/auth/logout')
        .then(response => {
            if (response && response.data) return response.data;
        })
    },

    getSuppliersImages () {
        return axios.get('/api/auth/suppliers-logo')
        .then(response => {
            if (response && response.data) return response.data;
        })
    },

    createCode (username, password, confPassword) {
        return axios.post('/api/auth/createCode', {username: username,password:password,confPassword:confPassword}  )
        .then(response => {
            if (response && response.data){
                return response.data;
            } 
        })
    },

    resetPassword (username, code) {
        return axios.post('/api/auth/resetPassword', {username: username,passwordCode:code}  )
        .then(response => {
            if (response && response.data){
                return response.data;
            } 
        })
    },


}

